<template>
	<div class="surf-detail-header-affix" :class="[offset !== 0 && 'with-offset']" :style="{ top: `${realOffset}px` }">
		<slot />
	</div>
</template>

<script setup>
import { onMounted, ref, nextTick, computed } from 'vue';

const props = defineProps({
	offset: {
		type: Number,
		default: 0
	},
	affixToMobNav: {
		type: Boolean,
		default: false
	}
});

const realOffset = computed(() => {
	if (props.offset) {
		return props.offset;
	}
	if (navOffset.value) {
		return navOffset.value;
	}
	return 0;
});

const navOffset = ref(0);
const calcOffsetWithNav = () => {
	const wrap = document.getElementById('surfMobNavContainer');
	if (wrap) {
		const targetRect = wrap.getBoundingClientRect();
		const offset = targetRect.height;
		navOffset.value = offset;
	}
};
onMounted(async () => {
	if (props.affixToMobNav) {
		await nextTick();
		calcOffsetWithNav();
	}
});
</script>
<style lang="less" scoped>
@surf-content-padding: 24px;

.surf-detail-header-affix {
	padding-top: 18px;
	background: var(--theme-color);
	padding-bottom: @surf-content-padding;

	position: sticky;
	z-index: 7;

	&.with-offset {
		padding-top: 0;
	}
}

.mob-surf-layout {
	.surf-detail-header-affix {
		padding-top: 12px;
		padding-bottom: 20px;
	}
}
</style>
